import { Link } from 'react-router-dom';
import { USERS } from '@/shared/data';
import { Avatar } from '@/shared/ui/Avatar';

export function StoryRail() {
  const featured = USERS.slice(0, 8);
  return (
    <section data-testid="story-rail" className="px-4 mb-2">
      <div className="flex gap-4 overflow-x-auto scrollbar-hide pb-2 snap-x">
        {featured.map((u, i) => (
          <Link
            key={u.id}
            data-testid="story-item"
            data-username={u.username}
            to={`/instaflix/profile/${u.username}`}
            className="flex-shrink-0 flex flex-col items-center gap-1.5 active:scale-95 transition-transform snap-start"
          >
            <Avatar
              src={u.avatar}
              alt={u.username}
              size={64}
              ring={i % 3 === 0 ? 'rose' : 'none'}
            />
            <span className="text-[11px] text-white/70 truncate max-w-[64px]">
              {u.username.split('.')[0]}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
